import { PopupboxManager } from 'react-popupbox'
import React from 'react'
import { Fragment } from '@wordpress/element'
import ModalNavigation from './ModalNavigation'

const listenForKeys = (e, key, photos, updateKeyCallback) => {
  let changeKey = false

  if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
    if ((key + 1) <= (photos.length - 1)) {
      ++key
      changeKey = true
    }
  }

  if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
    if ((key - 1) >= 0) {
      --key
      changeKey = true
    }
  }

  if (changeKey) {
    PopupboxManager.update({
      content: displayContent(photos[key]),
      config: {
        titleBar: {
          enable: !!(photos[key].category),
          text: photos[key].category
        }
      }
    })
    updateKeyCallback(key)
  }
}

const toggleModal = (key, photos) => {
  const updateKeyCallback = (value) => { key = value }
  const listenerName = (e) => listenForKeys(e, key, photos, updateKeyCallback)

  document.addEventListener('keydown', listenerName)

  PopupboxManager.open({
    content: displayContent(photos[key]),
    config: {
      titleBar: {
        enable: !!(photos[key].category),
        text: photos[key].category
      },
      onClosed: () => {
        document.removeEventListener('keydown', listenerName)
      }
    }
  })
}

const displayContent = ({
  branchSubsection,
  category,
  companies,
  decadeTimeframe,
  service,
  title,
  time,
  users,
  url,
  year
}) => {
  const {
    allClassmates
  } = /** @type {PhotoSearchDataSet} */ window.PhotoSearchData

  return (
    <Fragment>
      <ModalNavigation />
      <div className='popup-image-box'>
        <img src={url} alt={title} />
      </div>
      <div className='popup-details-box'>
        <ul>
          <li>{time}</li>
          {(() => (title ? <li>{title}</li> : ''))()}
          {(() => {
            if (users) {
              const userList = allClassmates.filter((o) => users.split(',').includes((o.ID + '')))
              const linkedUsers = userList.map((o, j, k) => {
                if (k.length > 1 && j < (k.length - 1)) {
                  return (
                    <Fragment key={j}>
                      <a
                        href={o.url}
                        onClick={() => {
                          console.log('Url update?', o.url)
                          window.href = o.url
                        }}
                      >
                        {o.postTitle}
                      </a>,
                    </Fragment>
                  )
                } else {
                  return (
                    <a
                      href={o.url}
                      key={j}
                      onClick={() => {
                        console.log('Url update, single?', o.url)
                        window.href = o.url
                      }}
                    >
                      {o.postTitle}
                    </a>
                  )
                }
              })
              return <li>{linkedUsers}</li>
            }
            return ''
          })()}
          {(() => (companies ? <li>{companies.split(',').join(', ') + ' Company'}</li> : ''))()}
          {(() => {
            const reunions = ['35th Reunion', '40th Reunion', '45th Reunion']
            if (category === 'Academy Years') {
              return (
                <Fragment>
                  {(() => (decadeTimeframe ? <li>{decadeTimeframe}</li> : ''))()}
                </Fragment>
              )
            } else if (category === 'In Uniform') {
              return (
                <Fragment>
                  {(() => (decadeTimeframe ? <li>{decadeTimeframe}</li> : ''))()}
                  {(() => (service ? <li>{service}</li> : ''))()}
                  {(() => (branchSubsection ? <li>{branchSubsection}</li> : ''))()}
                </Fragment>
              )
            } else if (category === 'Post Military Life') {
              return (
                <Fragment>
                  {(() => (decadeTimeframe ? <li>{decadeTimeframe}</li> : ''))()}
                  {(() => (year ? <li>{year}</li> : ''))()}
                </Fragment>
              )
            } else if (reunions.includes(category)) {
              return (
                <Fragment>
                  {(() => (branchSubsection ? <li>{branchSubsection}</li> : ''))()}
                </Fragment>
              )
            }
          })()}
        </ul>
      </div>
    </Fragment>
  )
}

export default toggleModal
